'use strict'

function visibleFieldDescription (description) {

  if (typeof description !== 'string') return ''

  return description.trim()
}

module.exports = {
  visibleFieldDescription
}
